import React from 'react';

export default class extends React.Component {
    render() {
        return (
            <svg width="66" height="26" viewBox="0 -2 60 30" version="1.1">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                    <polygon strokeWidth="2" points="46.3292 25.7816 0.0002 25.7816 6.8932 -0.000400000001 53.2222 -0.000400000001"></polygon>
                    <polyline strokeWidth="2" points="47.5206 22.8875 59.2536 22.8875 58.3916 19.6645 57.5306 16.4415 56.6686 13.2195 55.8076 9.9965 54.9456 6.7735 54.0836 3.5515 53.2226 0.3285"></polyline>
                    <path d="M9.5206,18.8875 L22.7796,18.8875 C24.9886,18.8875 27.5096,16.3915 28.1596,14.2655 L29.2366,10.7425 C29.8866,8.6165 28.6186,6.8875 26.4096,6.8875 L12.5206,6.8875" strokeWidth="2"></path>
                    <path d="M21.5206,14.8875 L10.5206,14.8875" strokeWidth="2"></path>
                    <path d="M22.5206,10.8875 L11.5206,10.8875" strokeWidth="2"></path>
                    <path d="M21.4323,17.9183 L24.5263,7.7983" strokeWidth="2"></path>
                    <path d="M43.5206,12.8875 L29.5206,12.8875" strokeWidth="2"></path>
                </g>
            </svg>
        );
    }
}
